import React from 'react';
import UserItemWebinar from './UserItemWebinar.jsx'
import TablePagination from 'components/Pagination/TablePagination';
import HeaderNewWebinar from './HeaderNewWebinar.jsx';

export const UserListWebinar = ({
                           users,
                           checkedUserIds,
                           user_ids,
                           paginationProps,
                           onOrderChange,
                           query
                         })  => <table>
  <HeaderNewWebinar
    onChange={onOrderChange}
    value={query.order}
  />
  { users.map(user => (
    <UserItemWebinar
      user={user}
      checkedUserIds={checkedUserIds}
      key={user.id}
      user_ids={user_ids}
    />
  ))}
  <tr>
    <td colSpan="9">
      <TablePagination
        {...paginationProps}
      />
    </td>
  </tr>
</table>



// WEBPACK FOOTER //
// ./src/components/AddUsersWebinar/UserListWebinar.jsx